import React, { useState, useEffect, useCallback } from "react";
import { getSourcesSingleExternal } from "../api/quontxApi";
import Pagination from "../components/Pagination"; // Import the reusable component
import { useNavigate } from "react-router-dom";

const ITEMS_PER_PAGE = 9; // A 3x3 grid looks nice

const Sources = () => {
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleCardClick = (uuid) => {
    navigate(`/sources/${uuid}/etl-configs`);
  };

  // Add state for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  // Update data fetching function
  const fetchSources = useCallback(async (page) => {
    setLoading(true);
    try {
      const response = await getSourcesSingleExternal(page, ITEMS_PER_PAGE);
      // Parse the new API response structure
      setSources(response.data.data || []);
      setTotalItems(response.data.total_count || 0);
      setCurrentPage(page);
    } catch (err) {
      setError("Failed to fetch sources.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Fetch data for the current page
    fetchSources(currentPage);
  }, [fetchSources, currentPage]);

  const handlePageChange = (page) => {
    fetchSources(page);
  };

  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  if (loading && sources.length === 0)
    return <div className="text-center p-8">Loading sources...</div>;
  if (error) return <div className="text-center p-8 text-red-400">{error}</div>;

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-white mb-6">Sources</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {sources.map((source) => (
          <div
            key={source.id}
            className="bg-qtx-darker p-6 rounded-lg shadow-lg cursor-pointer"
            onClick={() => handleCardClick(source.uuid)}
          >
            <h2 className="text-xl font-semibold text-white">{source.name}</h2>
            <p className="text-qtx-gray mt-2">ID: {source.uuid}</p>
            <p className="text-qtx-light-gray mt-1">
              Type:{" "}
              <span className="font-mono bg-qtx-dark px-2 py-1 rounded">
                {source.url_root}
              </span>
            </p>
          </div>
        ))}
      </div>

      {/* Render the Pagination component below the grid */}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default Sources;
